// extracted by mini-css-extract-plugin
export var aboveInput = "_iv-0";
export var actionButton = "_iv-5";
export var actionButtonContainer = "_iv-1";
export var actionIcon = "_iv-6";
export var aiInfoContainer = "_iv-2";
export var attachmentWrapper = "_iv-7";
export var bold = "_iv-3";
export var checkIcon = "_iv-8";
export var clickingRecipientBar = "_iv-11";
export var commentThreadSwitch = "_iv-a";
export var draftImage = "_iv-b";
export var draftImageContainer = "_iv-c";
export var draftImages = "_iv-e";
export var editButton = "_iv-g";
export var editor = "_iv-f";
export var editorContainer = "_iv-y";
export var editorErrorTooltipWrapper = "_iv-9";
export var headerDivider = "_iv-h";
export var icon = "_iv-i";
export var info = "_iv-j";
export var internal = "_iv-n";
export var internalDivider = "_iv-k";
export var internalMessage = "_iv-l";
export var messageInputCard = "_iv-m";
export var messageInputForm = "_iv-o";
export var messageInputFormInternal = "_iv-p";
export var options = "_iv-q";
export var publicMessageCustomer = "_iv-s";
export var publicMessageMerchant = "_iv-r";
export var removeImageButton = "_iv-d";
export var replyButtons = "_iv-t";
export var showSignatureButton = "_iv-u";
export var spinner = "_iv-v";
export var verticalButtonDivider = "_iv-4";
export var visibilitySelector = "_iv-w";
export var warning = "_iv-x";
export var wrappingText = "_iv-z";
export var writingInternalNoteTopBorder = "_iv-10";